// @mui
import PropTypes from 'prop-types';
import { Box, Card, Skeleton, Tooltip, Typography } from '@mui/material';
// utils
import { formatCurrency } from '../../../utils/formatNumber';
// components

// ----------------------------------------------------------------------

// const StyledIcon = styled('div')(({ theme }) => ({
//     margin: 'auto',
//     display: 'flex',
//     borderRadius: '50%',
//     alignItems: 'center',
//     width: theme.spacing(8),
//     height: theme.spacing(8),
//     justifyContent: 'center',
//     marginBottom: theme.spacing(3)
// }));

// ----------------------------------------------------------------------

AppWidgetSummary.propTypes = {
    color: PropTypes.string,
    icon: PropTypes.string,
    list: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            amount: PropTypes.number
        })
    ),
    sx: PropTypes.object
};

export default function AppWidgetSummary({
    title,
    list,
    count,
    showOnlyCount = false,
    countTooltip,
    icon,
    color = 'primary',
    sx,
    loading,
    ...other
}) {
    const skeletonRows = Array.isArray(list) && list.length ? list.length : 2;
    console.log('loading', loading);
    return (
        <Card
            sx={{
                height: '100%',
                p: 2.5,
                boxShadow: 0,
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-around',
                color: (theme) => theme.palette[color].darker,
                bgcolor: (theme) => theme.palette[color].lighter,
                ...sx
            }}
            {...other}
        >
            {/*<StyledIcon*/}
            {/*    sx={{*/}
            {/*        color: (theme) => theme.palette[color].dark,*/}
            {/*        backgroundImage: (theme) =>*/}
            {/*            `linear-gradient(135deg, ${alpha(*/}
            {/*                theme.palette[color].dark,*/}
            {/*                0*/}
            {/*            )} 0%, ${alpha(theme.palette[color].dark, 0.24)} 100%)`*/}
            {/*    }}*/}
            {/*>*/}
            {/*    <Iconify icon={icon} width={24} height={24} />*/}
            {/*</StyledIcon>*/}
            <Typography variant="h6" sx={{ opacity: 0.72 }}>
                {title}
            </Typography>

            {loading ? (
                <>
                    {showOnlyCount ? (
                        <Skeleton
                            variant="text"
                            height={48}
                            width="60%"
                            sx={{ mx: 'auto' }}
                        />
                    ) : (
                        Array.from({ length: skeletonRows }).map((_, idx) => (
                            <Box key={idx} textAlign="left" mt={1}>
                                <Skeleton
                                    variant="text"
                                    height={18}
                                    width="75%"
                                />
                                <Skeleton
                                    variant="text"
                                    height={32}
                                    width="55%"
                                />
                            </Box>
                        ))
                    )}
                </>
            ) : (
                <>
                    {showOnlyCount && (
                        <Tooltip title={countTooltip || ''}>
                            <Typography variant="h4">
                                {formatCurrency(count)}
                            </Typography>
                        </Tooltip>
                    )}

                    {Array.isArray(list) &&
                        list.map((item, index) => (
                            <Tooltip title={item.tooltip || ''} key={index}>
                                <Box
                                    display="flex"
                                    flexDirection="column"
                                    textAlign="left"
                                    mt={1}
                                >
                                    <Typography
                                        variant="subtitle2"
                                        sx={{ opacity: 0.72 }}
                                    >
                                        {item.title}
                                    </Typography>
                                    <Typography variant="h5">
                                        {formatCurrency(item.amount)}
                                    </Typography>
                                </Box>
                            </Tooltip>
                        ))}
                </>
            )}
        </Card>
    );
}
